// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    :
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : background tasks for widget package
// =============================================================================
// ---Third-party imports
import {takeEvery, put} from 'redux-saga/effects'

// ---Framework imports
import {delay} from 'uix/sagas'
import Api from 'uix/api'
import log from 'uix/logging'

// ---Local imports
import {loadWidgetData, setWidgetData} from './actions'

// ---Globals
function* _loadWidgetData({payload, meta}) {
  let otids = payload.otids
  let {data, error} = yield Api.get('/api/getWidgetData', {otids: otids.join(',')})
  if (error) {
    log.error('bad things on getWidgetData')
  } else {
    yield put(setWidgetData(data.widgetData))
  }
}

export const sagas = {
  loadWidgetData: takeEvery(loadWidgetData, _loadWidgetData),
}
